// extracted by mini-css-extract-plugin
module.exports = {"control":"control_control__3_82U"};